import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class CustomDev extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Custom Dev </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>WE CREATE JAW-DROPPING CUSTOM XR (AR/VR/360) EXPERIENCES</b>
                      <br></br>
                      Until a few years ago, business usecases of XR were restricted 
                      to very niche uses such as in aerospace, research and development and military.

                      But, as the technology to power affordable virtual experiences is finally here, 
                      it has opened a world of possibilities that we are only beginning to comprehend.

                      Imagine putting new recruits in a virtual replica of the environment they will 
                      be working in, and letting them practice their skills till they are perfect.

                      Or, allowing children in a classroom to experience a famous historical battle 
                      from the eyes of a soldier.

                      Or, how about creating 360 virtual experiences that can completely engross consumers 
                      in a company’s message?

                      All these scenarios are no longer science fiction, 
                      they are science fact and are here to stay.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Custom X-tended Reality App Development</b>
                      <br></br>
                      AbilitàXR has been creating highly realistic XR apps that 
                      are as instructional as they are immersive and now we can create one for you, too. We can make:
                      <br></br>
                      a. Educational XR apps <br></br>
                      b. XR training tools <br></br>
                      c. Healthcare apps <br></br>
                      d. XR product demos <br></br>
                      e. XR games <br></br>
                      f. XR facility tours <br></br>
                      g. XR architectural visualization
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>XR Training Solutions for Companies</b>
                      <br></br>
                      Powerpoint presentations are so 2003, and hands-on training always carries the risk of accidents. 
                      With XR, you can train your employees in a 3D reconstruction of their workspace, 
                      complete with a virtual instructor. Not only can they perform every step until it is being 
                      perfectly executed, but they can also go back for refresher courses whenever they feel like it. 
                      <br></br>
                      By implementing a VR powered training program, your enterprise can drastically reduce the cost 
                      and time required to train new recruits, all while reducing the chances of any workplace incidents. 
                      Not to mention, your employees will enjoy the experiences thoroughly!                   
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Educational Virtual Reality Solutions for Schools and Organizations</b>
                      <br></br>
                      Children already have very active imaginations and with VR, you can give them a chance 
                      to find themselves right in their imaginary worlds, all while they learn. 
                      As humans still learn best through direct experience, a child will have a 
                      far more lasting memory of what he/she has learned if they saw it first hand.
                      <br></br>
                      Immersiveness was the missing ingredient from the curriculum of modern education, 
                      which VR provides in spades. Let your children see visual replicas of the human 
                      body to understand its workings, take a tour of the ISS and see Earth from orbit 
                      and roam a wild field with dinosaurs to understand how prehistoric animals lived!
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Branded X-tended Reality Content for Sales and Marketing</b>
                      <br></br>
                      A trade show booth that gives its attendees a chance to visit an exotic 
                      location without needing to step outside will always have better attendance 
                      than its competitors. But that’s the tip of the virtual iceberg. XR powered 
                      marketing has the ability to forge much deeper connections than any format ever 
                      thanks to its ability to put the viewer right in the middle of an experience. 
                      We can create highly engaging, branded XR content that will drive traffic to your booth, 
                      storefront or website and leave your audience asking for more!
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Our Process is a more understandable custom software experience</b>
                      <br></br>
                        a. DISCOVERY & ANALYSIS <br></br>
                        You meet your project's personal digital producer! They start by discussing your vision, 
                        goals and measure of success. This becomes our team's vision and we map out a plan, 
                        using analytics and our wide array of in-house resources to target that success.
                        <br></br>
                        b. UX & UI DESIGN <br></br>
                        Our user experience (UX) team builds wireframe 'blueprints' for your project, 
                        focusing on the experience your users will have. Then, our user interface (UI) 
                        artists make it pop with your branding, design and personality. 
                        Our goal is that every pixel feels 100% like you.
                        <br></br>
                        c. DEVELOPMENT & QA <br></br>
                        Our in-house team of expert developers and computer vision specialists get to work, 
                        turning your project into a functioning reality! We provide test versions of your 
                        project so you can give feedback every step along the way.
                        <br></br>
                        d. MARKETING & USER ACQUISITION <br></br>
                        We help to optimize your app store presence, ensure the approval process goes as planned 
                        and even can help you acquire users through advertising, social marketing and PR.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>What industry are you in? Time to benefit from XR!</b>
                    </h6>
                  </Col>  

                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                    
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Just for Fun </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/realestate.png" />
                        <h6 className = "text-center mt-3"> Real Estate </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/architecture.png" />
                        <h6 className = "text-center mt-3"> Architecture </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/medical.png" />
                        <h6 className = "text-center mt-3"> Medical </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/retail.png" />
                        <h6 className = "text-center mt-3"> Retail </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/sports.png" />
                        <h6 className = "text-center mt-3"> Sports </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/media.png" />
                        <h6 className = "text-center mt-3"> Media </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/travel.png" />
                        <h6 className = "text-center mt-3"> Travel </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/education.png" />
                        <h6 className = "text-center mt-3"> Education </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/training.png" />
                        <h6 className = "text-center mt-3"> Training </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/ecommerce.png" />
                        <h6 className = "text-center mt-3"> Ecommerce </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "/assets/img/entertainment.png" />
                        <h6 className = "text-center mt-3"> Entertainment </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2"></Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default CustomDev;



// WEBPACK FOOTER //
// ./src/views/Pages/CustomDev/CustomDev.js